<template>
  <div class="row">
    <work-menu></work-menu>
    <div class="col-md-10 pt-3" v-if="hasAnyRole('ROLE_ADMIN','ROLE_WORK_READ','ROLE_WORK_ADMIN')">
      <div>
          <div class="form-group">
              <span>年</span>
              <select class="search-select custom-select mr-1" name="year" v-model="selectedYear" @change="changeSelected">
                  <option v-for="year in yearList" :value="year" :key="year">
                          {{year}}
                  </option>
              </select>
              <span>部署</span>
              <select class="search-select custom-select mr-1" name="department" v-model="selectedDepartmentId" @change="changeSelected">
                  <option value="" selected="selected" v-if="hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')">すべて</option>
                  <option v-for="(current, index) in loginUser.departmentList" :value="loginUser.departmentIdList[index]" :key="index">
                          {{current}}
                  </option>
              </select>
              <label ref="viewAll"><input type="checkbox" id="viewAll" @click="checkUserView">退職者も表示</label>
          </div>
      </div>
      <div v-if="annuallySummaryList.length == 0">まだレコードはありません</div>
      <div v-else>
        <table class="table table-sm table-bordered table-responsive">
            <thead class="thead-light">
            <tr>
                <th>氏名</th>
                <th>部署</th>
                <th>出勤数</th>
                <th>遅刻数</th>
                <th>早退数</th>
                <th>有給取得数</th>
                <th>休暇数</th>
                <th>特別休暇数</th>
                <th>代休数</th>
                <th>その他 諸定休暇数</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="result in annuallySummaryList" :key="result.userId" v-if="viewAll || result.deletedAt == null" :class="{'retiree': result.deletedAt}">
                    <td class="noflap">
                        <img class="card-img-top icon" :src="result.imageUrl ? result.imageUrl : ''" onerror="this.src='/src/assets/img/not_found_user_icon.jpg';">
                        {{result.userName}}
                    </td>
                    <td>{{result.unit}}</td>
                    <td class="text-right">{{result.workCount}}</td>
                    <td class="text-right">{{result.lateCount}}</td>
                    <td class="text-right">{{result.leaveEarlyCount}}</td>
                    <td class="text-right">{{result.yukyuCount}}</td>
                    <td class="text-right">{{result.dayOffCount}}</td>
                    <td class="text-right">{{result.specialDayOffCount}}</td>
                    <td class="text-right">{{result.substituteDayOffCount}}</td>
                    <td class="text-right">{{result.otherDayOffCount}}</td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style scoped>
.noflap{
 white-space: nowrap;
}
.retiree{
  background: #ccc;
}
.icon {
  border-radius: 50%;
  height: 45px;
  width: 45px;
}
</style>

<script>
import WorkAPI from '../../../api/work-api'
import CommonAPI from '../../../api/common-api'
import moment from 'moment'
import WorkMenu from './WorkMenu.vue'

export default {
  name: "work-annually-summary",
  components: {
    WorkMenu,
  },
  data() {
    return {
      loginUser: {
        role: ''
      },
      yearList: [],
      annuallySummaryList: [],
      selectedYear: moment().format("YYYY"),
      selectedDepartmentId: '',
      viewAll: false,
    }
  },
  watch: {
    '$root.$refs.asnHeader.$data.loginUser': function (val) {
        this.loginUser = this.$root.$refs.asnHeader.$data.loginUser
        if(!this.hasAnyRole('ROLE_ADMIN', 'ROLE_MANAGE')){
            this.selectedDepartmentId = this.loginUser.departmentIdList.length > 0 ? this.loginUser.departmentIdList[0] : ''
        }
        this.getWorkList()
        this.getYearList()
    },
  },
  mounted () {
    if (this.$route.query.year) {
        this.selectedYear = this.$route.query.year
    }
    if (this.$route.query.departmentId){
        this.selectedDepartmentId = this.$route.query.departmentId;
    }
  },
  methods: {
    // 年一覧取得
    getYearList () {
      WorkAPI.getYearList()
        .then(res => {
            this.yearList = res
        })
        .catch(err => {
            console.error(err)
        })
    },
    // 勤怠一覧取得
    getWorkList () {
      this.$root.$refs.loading.$data.show = true
      let params = {}
      params['year'] = this.selectedYear
      params['departmentId'] = this.selectedDepartmentId
      WorkAPI.getAnnuallySummary(params)
        .then(res => {
            this.annuallySummaryList = res
            this.$nextTick(function() {
                this.$root.$refs.loading.$data.show = false
            })
        })
        .catch(err => {
            console.error(err)
            this.$root.$refs.loading.$data.show = false
        })
    },
    // 権限を持っているか判定
    hasAnyRole: function (...args) {
        for (var i = 0; i < arguments.length; i++) {
            if (this.loginUser.role.includes(arguments[i])) {
                return true
            }
        }
        return false
    },
    // 退職者も表示
    checkUserView() {
      this.viewAll = !this.viewAll
    },
    // セレクト変更時
    changeSelected () {
        // 履歴を追加
        this.$router.push("/admin/work/annually-summary?year=" + this.selectedYear
        + "&departmentId=" + this.selectedDepartmentId)
        // データの再取得
        this.getWorkList()
    },
  },
  filters: {
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/admin/work/WorkAnnuallySummary.vue